import { PdpDataProvider } from "@/components/pdp/PdpDataContext";
import MegaHeaderV3 from "@/components/home/MegaHeaderV3";
import RiversolFooter from "@/components/pdp/RiversolFooter";
import { EYE_REPAIR_V31 } from "@/data/eyeRepairV31";
import HomeHero, { SLIDES } from "@/components/home/HomeHero";
import TrustBadgeMarqueeV3 from "@/components/home/TrustBadgeMarqueeV3";
import CollectionsSliderV3 from "@/components/home/CollectionsSliderV3";
import AnalyzeSkinV3 from "@/components/home/AnalyzeSkinV3";
import NumberProof from "@/components/home/NumberProof";
import BetaTScienceV3 from "@/components/home/BetaTScienceV3";
import FourStepsV3 from "@/components/home/FourStepsV3";
import DrRiversV3 from "@/components/home/DrRiversV3";
import BestSellers from "@/components/home/BestSellers";
import QuickFinder from "@/components/home/QuickFinder";
import DermatologyProofV3 from "@/components/home/DermatologyProofV3";
import IngredientTrioV3 from "@/components/home/IngredientTrioV3";
import RiversolInActionHome from "@/components/home/RiversolInActionHome";
import PressStrip from "@/components/home/PressStrip";
import { FaqSection } from "@/components/pdp/DetailsAndFaq";

// HP3 hero deck — the serum slide ("Hydration That Sinks In", mirroring the
// live riversol.com hero) sits SECOND; the shared hydrogel-mask slide leads.
// The serum photo has a white background, so its copy renders in dark ink.
const HP3_SLIDES = [
  ...SLIDES.slice(1),
  {
    headline: ["Hydration", "That Sinks In"],
    body:
      "Meet our new Hyaluronic Acid Hydrating Serum, dermatologist-developed to deeply quench thirsty skin, smooth dehydration lines and calm visible redness.",
    primary: { label: "Shop the Serum", href: "https://www.riversol.com/products/hyaluronic-acid-hydrating-serum" },
    secondary: { label: "Shop All", href: "https://www.riversol.com/collections/all" },
    image:
      "https://customer-assets-gfyr7b9c.emergentagent.net/job_e3513a08-18b3-459d-901e-2457595c9150/artifacts/9f9fyx41_image.png",
    focal: "72% 42%",
    tint: "from-transparent via-transparent to-transparent",
    darkCopy: true,
    alt: "Hyaluronic Acid Hydrating Serum — Hydration that sinks in",
  },
];

// HP3 — a THIRD, shorter/simpler homepage direction (client written feedback,
// NOT their Figma — that becomes V4 later). ~80% familiar premium skincare UX
// + 20% Riversol CRO. Scoped in `.home-scope hp3`; V1 (Home) and V2 (Hp2) are
// untouched. Reuses proven components where useful; Dermatology+Proof and the
// Ingredient trio are new concise V3 compositions. Desktop-first pass.
//
// Section order:
//  01 Hero · 02 Shop by Concern · 03 Best Sellers (with embedded Bundle & Save,
//  step 05) · 04 Find What Works · 06 Dermatology + Proof · 07 Ingredient
//  Spotlight · 08 Riversol in Action · 09 In the Press · 10 Footer.
export default function Hp3() {
  return (
    <PdpDataProvider data={EYE_REPAIR_V31}>
      <div className="home-scope hp3">
        <MegaHeaderV3 />
        <main data-testid="home-page-v3">
          <HomeHero sticky slides={HP3_SLIDES} />
          {/* Everything after the hero scrolls OVER the pinned hero
              (Ex Nihilo-style reveal) — solid backgrounds + z-10. */}
          <div className="relative z-10">
            <TrustBadgeMarqueeV3 />
            <CollectionsSliderV3 />
            <AnalyzeSkinV3 />
            <NumberProof />
            <BetaTScienceV3 />
            <FourStepsV3 />
            <DrRiversV3 />
            <PressStrip showHeading={false} showDividers={false} />
            <RiversolInActionHome />
            <FaqSection headingRight />
          </div>
        </main>
        <RiversolFooter hp3 />
      </div>
    </PdpDataProvider>
  );
}
